import GridViewOutlinedIcon from '@mui/icons-material/GridViewOutlined';
import ViewDayOutlinedIcon from '@mui/icons-material/ViewDayOutlined';
import { Stack, ToggleButton, ToggleButtonGroup } from '@mui/material';
import React from 'react';

import { ReportJobNestedSectionLayoutMode } from 'utils/reportJobSections';

interface Props {
  value: ReportJobNestedSectionLayoutMode;
  onChange: (value: ReportJobNestedSectionLayoutMode) => void;
}

const ReportJobSectionDisplayModeToggle: React.FC<Props> = ({ value, onChange }) => (
  <Stack sx={{ minWidth: 0 }}>
    <ToggleButtonGroup
      size="small"
      color="primary"
      value={value}
      exclusive
      aria-label="Nested subsection layout mode"
      onChange={(_event, newValue: ReportJobNestedSectionLayoutMode | null) => {
        if (!newValue) {
          return;
        }

        onChange(newValue);
      }}
    >
      <ToggleButton value="one-up">
        <Stack direction="row" spacing={0.75} alignItems="center">
          <ViewDayOutlinedIcon fontSize="small" />
          <span>1 per row</span>
        </Stack>
      </ToggleButton>
      <ToggleButton value="two-up">
        <Stack direction="row" spacing={0.75} alignItems="center">
          <GridViewOutlinedIcon fontSize="small" />
          <span>2 per row</span>
        </Stack>
      </ToggleButton>
    </ToggleButtonGroup>
  </Stack>
);

export default ReportJobSectionDisplayModeToggle;
